const RESULT_KEYS = {
  company_initial_backfill: ["pos_integration_backfill", "actuals_backfill", "labor_driver_sales_backfill", "historical_schedules_backfill"],
  backfills_run: ["pos_integration_backfill", "actuals_backfill", "labor_driver_sales_backfill", "historical_schedules_backfill"],
  company_earned_labor_backfill: ["initial_earned_labor"],
  company_initial_forecast: ["initial_forecast"],
  company_labor_standard_optimization: [],
};

const JOB_LABELS = {
  pos_integration_backfill: "POS history import",
  actuals_backfill: "Sales and labor history import",
  labor_driver_sales_backfill: "Sales driver history import",
  historical_schedules_backfill: "Schedule history import",
  initial_earned_labor: "Earned labor calculation",
  initial_forecast: "Initial forecast",
  labor_standard_optimization: "Labor standards optimization",
};
const JOB_STATUSES = {
  complete: "Completed", completed: "Completed", success: "Completed",
  failed: "This attempt did not finish", running: "In progress",
  queued: "Queued", pending: "Pending", skipped: "Skipped",
};
function presentJob(key, job, location) {
  const date = job.updated_at ? new Date(job.updated_at) : null;
  return {
    name: [location, JOB_LABELS[key] || "Setup run"].filter(Boolean).join(" — "),
    status: JOB_STATUSES[job.status] || "Status unavailable",
    date: date && !Number.isNaN(date.getTime())
      ? date.toLocaleDateString("en-US", {month: "short", day: "numeric", year: "numeric"}) : null,
  };
}

export function completedTaskDetails(task, summary) {
  if (!["complete", "completed"].includes(task.status) || task.moduleOff) return null;
  const skipped = task.undoAction?.label?.toLowerCase() === "undo skip";
  const review = task.undoAction?.action === "undo";
  let description = skipped ? "Skipped for now." : review ? "Marked reviewed." : "Setup complete.";
  let action = task.primaryAction?.tab && !task.primaryAction.taskKey && !task.primaryAction.automation
    ? task.primaryAction : null;
  let inline = null;
  let results = [];
  if (task.key === "business_type_selected") {
    description = task.description;
    action = { label: "Edit business type", modal: "business_type" };
  } else if (task.key === "concepts_reviewed") {
    action = { label: "Edit concepts", modal: "company_concepts" };
  } else if (task.key === "starting_modules_selected") {
    const modules = summary?.company?.modules;
    description = modules
      ? modules.scheduling && modules.training ? "Scheduling and training enabled."
        : modules.scheduling ? "Scheduling enabled; training off."
          : modules.training ? "Training enabled; scheduling off." : "Scheduling and training are off."
      : task.description;
    action = { label: "Edit features" };
    inline = "features";
  } else if (task.key === "company_pos_connected" || task.key === "store_pos_linked") {
    description = task.salesEntryMode === "manual" ? "Manual sales entry" : skipped ? description : "POS connected. View the integration and linked locations.";
    action = { label: task.salesEntryMode === "manual" || skipped ? "Connect a POS" : "View integration", intent: "connect_pos", ...(task.salesEntryMode === "manual" ? {taskKey: "company_pos_connected", scope: "company", action: "pos_sales"} : {}), tab: "locationsIntegrationsHoursSettings", ...(task.store_id ? {store_id: task.store_id} : {}) };
  } else if (task.key === "real_location_added") {
    description = "Locations added. View their current configuration.";
  } else if (task.key === "training_content_started") {
    description = skipped ? description : review ? "Marked done." : "Published training content is available.";
    if (action) action = { ...action, label: "View training tracks" };
  }
  if (Object.prototype.hasOwnProperty.call(RESULT_KEYS, task.key)) {
    inline = "results";
    action = { label: "View results" };
    const stores = (summary?.storeSummaries || []).filter(s => !task.store_id || Number(s.store_id) === Number(task.store_id));
    results = stores.flatMap(store => RESULT_KEYS[task.key].flatMap(key => {
      const job = store.automationJobs?.[key];
      return job ? [presentJob(key, job, store.store_name)] : [];
    }));
    if (!results.length && task.jobStatus && typeof task.jobStatus === "object") {
      results = Object.entries(task.jobStatus).map(([key, job]) => presentJob(key, job));
    }
    description = skipped ? "Skipped for now; any recorded results are still available." : "Marked reviewed. Previous setup attempts are available below.";
  }
  return { description, action, inline, results };
}
